export default __webpack_public_path__ + "static/proxima-nova-300-1b8f6e0b8483ed545c11a7ca8fda422a.woff2";